import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { HotelInformation } from '../../shared/models/hotel-information.model';

export const HotelInformationActions = createActionGroup({
  source: 'Hotel Information',
  events: {
    Load: emptyProps(),
    'Load Success': props<{ hotelInformation: HotelInformation }>(),
    'Load Failure': props<{ error: string }>(),
    Clear: emptyProps(),
  },
});
